/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { IVisitor } from '../../core/visitors/IVisitor';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends ExtensibleNode
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiHeaderItem extends ExtensibleNode implements IReferenceNode {
    public $ref : string;

    /**
     * We do not support deserialization of `Schema Object` yet.
     * In TypeScript, this field contains the raw JS object, in case of Java
     * it is a {@link com.fasterxml.jackson.databind.node.ObjectNode}.
     * 
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#schemaObject">AsyncAPI 2.0.0 spec</a>
     */
    public _schemaRaw : any;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            if(this.$ref===undefined) this.$ref = null;
            if(this._schemaRaw===undefined) this._schemaRaw = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this._schemaRaw===undefined) this._schemaRaw = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this.$ref===undefined) this.$ref = null;
            if(this._schemaRaw===undefined) this._schemaRaw = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this._schemaRaw===undefined) this._schemaRaw = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitHeaderItem(this);
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }
}
AaiHeaderItem["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiHeaderItem";
AaiHeaderItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode"];




